var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"categories-view"},[_c('categories-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }